const unitName = (param) => {
  let perUnit = {}

  switch (param) {
    case 'Tiles':
      perUnit = {
        plural: 'Tiles',
        singular: 'Tile',
      }
      return perUnit
    case 'TilesWithTypes':
      perUnit = {
        plural: 'Tiles',
        singular: 'Tile',
      }
      return perUnit
    case 'Foam Tiles':
      perUnit = {
        plural: 'Tiles',
        singular: 'Tile',
      }
      return perUnit
    case 'Mat':
      perUnit = {
        plural: 'Mats',
        singular: 'Mat',
      }
      return perUnit
    case 'Foam Mats':
      perUnit = {
        plural: 'Mats',
        singular: 'Mat',
      }
      return perUnit
    case 'BoxedPlank':
      perUnit = {
        plural: 'Boxes',
        singular: 'Box',
      }
      return perUnit
    case 'BoxedTiles':
      perUnit = {
        plural: 'Boxes',
        singular: 'Box',
      }
      return perUnit
    case 'PreCutRoll':
      perUnit = {
        plural: 'Rolls',
        singular: 'Roll',
      }
      return perUnit
    case 'CustomCutRoll':
      perUnit = {
        plural: 'Rolls',
        singular: 'Roll',
      }
      return perUnit
    case 'Paver':
      perUnit = {
        plural: 'Pavers',
        singular: 'Paver',
      }
      return perUnit
    case 'Plank':
      perUnit = {
        plural: 'Planks',
        singular: 'Plank',
      }
      return perUnit
    case 'Mulch':
      perUnit = {
        plural: 'Bags',
        singular: 'Bag',
      }
      return perUnit
    default:
      perUnit = {
        plural: 'Items',
        singular: 'Item',
      }
      return perUnit
  }
}

export default unitName
